module.exports = __webpack_public_path__ + "img/square-lock.9f78bf4.svg";